import React from 'react';
import { Card, Text } from '@tremor/react';
import { usePopup } from '../../contexts/PopupContext';
import './UpcomingEvents.css';

function UpcomingEvents({ events, isLoading }) {
  const { openPopup } = usePopup();

  if (isLoading) {
    return (
      <Card className="upcoming-events-widget">
        <Text className="widget-title">Upcoming Events</Text>
        <div className="upcoming-events-loading">
          <Text>Loading...</Text>
        </div>
      </Card>
    );
  }

  // Pobierz najbliższe 2-3 wydarzenia
  const upcomingEvents = events
    .filter(event => {
      const eventDate = new Date(event.event_date + 'T' + (event.start_time || '00:00:00'));
      return eventDate >= new Date();
    })
    .slice(0, 3);

  if (upcomingEvents.length === 0) {
    return (
      <Card className="upcoming-events-widget">
        <Text className="widget-title">Upcoming Events</Text>
        <Text className="upcoming-events-empty">No upcoming events</Text>
      </Card>
    );
  }

  const formatEventTime = (event) => {
    const eventDate = new Date(event.event_date + 'T' + (event.start_time || '00:00:00'));
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    const isToday = eventDate.toDateString() === today.toDateString();
    const isTomorrow = eventDate.toDateString() === tomorrow.toDateString();
    
    if (isToday) {
      return `Today - ${event.start_time || 'TBA'}`;
    } else if (isTomorrow) {
      return `Tomorrow - ${event.start_time || 'TBA'}`;
    } else {
      return eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + 
             (event.start_time ? ` - ${event.start_time}` : '');
    }
  };

  return (
    <Card className="upcoming-events-widget">
      <Text className="widget-title">Upcoming Events</Text>
      <div className="upcoming-events-list">
        {upcomingEvents.map((event) => (
          <div
            key={event.id}
            className="upcoming-event-item"
            onClick={() => openPopup('event-details', { eventId: event.id }, 0)}
          >
            <div className="upcoming-event-content">
              <Text className="upcoming-event-name">{event.title}</Text>
              <Text className="upcoming-event-time">{formatEventTime(event)}</Text>
              {event.location && (
                <Text className="upcoming-event-location">{event.location}</Text>
              )}
            </div>
            <span className="upcoming-event-arrow">→</span>
          </div>
        ))}
      </div>
    </Card>
  );
}

export default UpcomingEvents;
